import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginModal from '../components/LoginModal';

const AuthModalContext = createContext(null);

export function useAuthModal() {
  const ctx = useContext(AuthModalContext);
  if (!ctx) {
    throw new Error('useAuthModal must be used within AuthModalProvider');
  }
  return ctx;
}

export function AuthModalProvider({ children }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [nextPath, setNextPath] = useState('/resume/contractor');

  const openLoginModal = useCallback((afterLoginPath = '/resume/contractor') => {
    const p = typeof afterLoginPath === 'string' && afterLoginPath.length > 0 ? afterLoginPath : '/resume/contractor';
    setNextPath(p);
    setOpen(true);
  }, []);

  const closeLoginModal = useCallback(() => setOpen(false), []);

  const handleLoggedIn = useCallback(() => {
    setOpen(false);
    navigate(nextPath, { replace: true });
  }, [navigate, nextPath]);

  const value = useMemo(
    () => ({ openLoginModal, closeLoginModal }),
    [openLoginModal, closeLoginModal]
  );

  return (
    <AuthModalContext.Provider value={value}>
      {children}
      {open ? <LoginModal onClose={closeLoginModal} onLoggedIn={handleLoggedIn} /> : null}
    </AuthModalContext.Provider>
  );
}
